export default __webpack_public_path__ + "static/media/in-between-dreams.324ba0a5.jpg";